import { IBTABlocks, IBTASearchOptions, TBTABookingDates } from "../Interfaces/BTA";
import { HTTPError } from "../Exceptions/HTTPError";
import { seasonStart } from "../Modules/RentalAndAppointments/Helper/DateRangePicker";

const yearSeconds = 60 * 60 * 24 * 365;

const endpoints = {
    frames: "frames",
    blocks: "blocks",
    search: "search",
    bookingDates: "booking-dates",
    product: "product"
};

const baseUrl = `${Shopify.routes.root}apps/bta-proxy/api/bta/`;

export class BookThatApi {
    constructor() {}

    #_start: Date;
    #_finish: Date;

    async fetchBlocks(variantId: string): Promise<IBTABlocks> {
        // Anfragen scheinen auf drei Monate begrenzt zu sein. Welchen Zeitraum wollen wir anzeigen?

        const start = new Date();
        const end = new Date(start.getTime() + 1000 * yearSeconds);

        const startParam = `${start.getFullYear()}-${(start.getMonth() + 1).toString().padStart(2, "0")}-${start
            .getDate()
            .toString()
            .padStart(2, "0")}T00:00`;
        const endParam = `${end.getFullYear()}-${(end.getMonth() + 1).toString().padStart(2, "0")}-${end
            .getDate()
            .toString()
            .padStart(2, "0")}T23:59`;

        const result = await fetch(
            `${baseUrl}${endpoints.blocks}?external_id=${variantId}&start=${startParam}&finish=${endParam}`,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
        if (result.status !== 200) {
            throw new HTTPError(result.status, result.statusText);
        }
        return await result.json();
    }

    async fetchBookingDates(productId: string): Promise<TBTABookingDates> {
        const result = await fetch(
            `${baseUrl}${endpoints.bookingDates}?external_product_id=${productId}&start_min=${seasonStart.format(
                "YYYY-MM-DD"
            )}&per=1000`,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
        if (result.status !== 200) {
            throw new HTTPError(result.status, result.statusText);
        }
        return await result.json();
    }

    async fetchProduct(productId: string) {
        const result = await fetch(`${baseUrl}${endpoints.product}?external_id[]=${productId}`, {
            headers: {
                "Content-Type": "application/json"
            }
        });
        if (result.status !== 200) {
            throw new HTTPError(result.status, result.statusText);
        }
        return await result.json();
    }

    async fetchSearch(options: IBTASearchOptions) {
        const result = await fetch(`${baseUrl}${endpoints.search}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                options: options
            })
        });

        if (result.status !== 200) {
            throw new HTTPError(result.status, result.statusText);
        }
        return await result.json();
    }

    set start(v: Date) {
        this.#_start = v;
    }

    set finish(v: Date) {
        this.#_finish = v;
    }
}
